import React, { useEffect, useState } from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';
import AccommodationForm from './AccommodationForm';
import { useLang } from '../i18n';

function HeroSection() {
  const [showBooking, setShowBooking] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    const video = document.getElementById('hero-video');
    if (video) {
      video.play().catch((error) => {
        console.error('Autoplay was prevented:', error);
      });
    }
  }, []);

  return (
    <div className='hero-container'>
      <video
        id="hero-video"
        src="/videos/video-5.mp4"
        autoPlay
        loop
        muted
        playsInline
        poster="/images/video-51.jpg"
        preload="metadata"
      ></video>
      <h1>Slovak Junior & Youth</h1>
      <p>{t('hero.subtitle')}</p>

      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
          linkTo='/info'
        >
          {t('hero.info')}
        </Button>
        <button
          className='btn btn--primary btn--large'
          onClick={() => setShowBooking(true)}
        >
          {t('hero.book')} <i className='fas fa-bed' />
        </button>
      </div>
      {showBooking && <AccommodationForm onClose={() => setShowBooking(false)} />}
    </div>
  );
}

export default HeroSection;